module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed",
    attrs: {
      "id": "community"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "feed-container"
  }, [_c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "instagrams",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".instagram",
      "fit-width": "true"
    }
  }, _vm._l((_vm.grams), function(gram, index) {
    return ((_vm.pageSize * _vm.atPage) > index) ? _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "instagram",
      class: {
        youtube: gram.type === 'youtube'
      },
      style: ({
        backgroundImage: 'url(' + gram.images.standard_resolution.url + ')',
        width: _vm.imageWidth + 'px',
        height: _vm.getHeight(gram.images.standard_resolution.width, gram.images.standard_resolution.height, _vm.imageWidth) + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.openGram(gram)
        }
      }
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      staticClass: "table"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_c('div', {
      staticClass: "hearts"
    }, [_c('i', {
      staticClass: "fa fa-heart"
    }), _vm._v(" " + _vm._s(gram.likes.count))]), _c('br'), _vm._v("\n              " + _vm._s(gram.user.username) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "outside"
    }, [(gram.type !== 'youtube') ? _c('div', {
      staticClass: "profile",
      style: ({
        backgroundImage: 'url(' + gram.user.profile_picture + ')'
      })
    }) : _vm._e(), _vm._v(" "), (gram.type === 'youtube') ? _c('div', {
      staticClass: "profile"
    }, [_c('i', {
      staticClass: "fa fa-youtube"
    })]) : _vm._e(), _vm._v(" \n          " + _vm._s(gram.user.username) + "\n        ")])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "40px",
      "margin-top": "30px"
    }
  }, [(_vm.grams.length > (_vm.atPage * _vm.pageSize)) ? _c('div', {
    staticClass: "load-more button",
    on: {
      "click": function($event) {
        _vm.atPage++
      }
    }
  }, [_vm._v("See more")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed-header"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v("#MYHONOR")]), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_vm._v("#FORTHEBRAVE")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/huaweisverige/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  }), _vm._v(" Follow us on Instagram @huaweisverige")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9f7b876","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feed.vue
// module id = 235
// module chunks = 1